import PropTypes from 'prop-types';
import { Box, Dialog, makeStyles, Divider, withStyles, Button, Theme, createStyles } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import {deleteExperiences} from '../../../store/actions/experience/experience';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    borderRadius: '24px!important'
  },
  createBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#ED564A',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#cc5b53'
    },
  },
  cancelBtn: {
    width: 91,
    height: 37,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#e0e0e0',
    },
  },

  label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  description: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    lineHeight: 1.5
  },
  name: {
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color: '#212D40',
    lineHeight: 0.9
  }
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'} />
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

DeleteExperiencesModal.propTypes = {
  onClose: PropTypes.func,
  clearAll: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selected: PropTypes.any,
};

DeleteExperiencesModal.defaultProps = {
  onClose: () => {
  }
};

function DeleteExperiencesModal({ open, onClose, selected, clearAll, ...rest }: any) {

  const classes = useStyles();
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);

  const onDelete = async () => {
    const request = { session_code: selected.map((item: any) => item.session_code) };
    dispatch(deleteExperiences(apolloClient.client, request, () => {
      clearAll();
      onClose();
    }))
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <div {...rest} >
        <DialogTitle onClose={onClose}>
          Delete Experiences?
        </DialogTitle>
        <Divider />

        <Box m={4} pl={1} pr={1}>
          <p className={classes.description}>
            Are you sure you want to delete the following Experiences?
            <br />
            This operation cannot be undone.
          </p>
        </Box>

        <Box m={4} pl={1} pr={1}>
          {selected.filter((_: any, k: number) => k < 3).map((item: any, index: number) =>
            <p className={classes.name} key={index}>
              {item.name}
            </p>)}

          {selected.length > 3 && <p className={classes.name}>
            + {selected.length - 3} more...
          </p>}
        </Box>

        <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
          <Button onClick={onClose} className={classes.cancelBtn}>
            Cancel
          </Button>
          &nbsp;&nbsp;&nbsp;
          <Button className={classes.createBtn} onClick={onDelete}>
            {'Delete'}
          </Button>
        </Box>
      </div>
    </Dialog>
  );
}

export default DeleteExperiencesModal;